import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.21903 9.99023C6.67903 9.99023 7.07903 10.3002 7.18903 10.7502L7.80903 13.2402C7.91903 13.6902 8.31903 14.0002 8.77903 14.0002H9.49903C10.049 14.0002 10.2547 13.5981 10.499 13.0002L11.999 9.00023V2.99023C11.999 2.44023 11.549 1.99023 10.999 1.99023H4.49903C4.03903 1.99023 3.63903 2.30023 3.52903 2.75023L2.02903 8.75023C1.86903 9.38023 2.34904 9.99023 2.99903 9.99023H6.21903ZM9.40175 13.0002H8.77981L8.15984 10.5104C7.93859 9.60998 7.13485 8.99023 6.21903 8.99023H2.99981L4.49919 2.99277L4.49981 2.99023H10.999V8.8189L9.56792 12.6352C9.51129 12.7734 9.46727 12.8741 9.4266 12.9537C9.41747 12.9715 9.40918 12.987 9.40175 13.0002Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.999 9.00023V3.00023C13.999 2.72023 13.779 2.50023 13.499 2.50023C13.219 2.50023 12.999 2.72023 12.999 3.00023V9.00023C12.999 9.28023 13.219 9.50023 13.499 9.50023C13.779 9.50023 13.999 9.28023 13.999 9.00023Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }